/**
* Dropdown overlay
*/
export function drowpdowOverlayInit() {
   const body = document.querySelector('body');
   const backdrop = document.querySelector('.site__backdrop');
   const backdropActiveClass = 'site__backdrop--show';
   const overlayableDropdowns = document.querySelectorAll('.js-dropdown-overlay');
   const site = document.querySelector('.site');

   overlayableDropdowns.forEach(dropdown => {

       dropdown.addEventListener('shown.bs.dropdown', function () {
           body.classList.add('body--backdrop-header');
           site.classList.add('site--backdrop-top')
           backdrop?.classList.add(backdropActiveClass);
       });

       dropdown.addEventListener('hidden.bs.dropdown', function () {
           body.classList.remove('body--backdrop-header');
           site.classList.remove('site--backdrop-top')
           backdrop?.classList.remove(backdropActiveClass);
       });
   });
}